import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppErrors, NotFoundError } from '@fitness-force/errors';
import { environment } from 'apps/ff-frontend/src/environments/environment';
import { throwError, Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class WaiverManagementService {
  constructor(private http: HttpClient) {}

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };

  createWaiver(payload: any, tenantId: number) {
    const url = `${environment.BASE_URL}/tenants/${tenantId}/waiver_mst`;
    return this.http
      .post(
        url,
        payload,
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  updateWaiver(waiverId: number, updatePayload: any, tenantId: number) {
    const url = `${environment.BASE_URL}/tenants/${tenantId}/waiver_mst/${waiverId}`; 

    return this.http
      .put(
        url,
        updatePayload,
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  getWaivers(tenantId: number): Observable<any> {
    const url = `${environment.BASE_URL}/tenants/${tenantId}/waiver_mst`;

    return this.http
      .get(url, this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  getWaiverById(waiverId: number, tenantId: number): Observable<any> {
    const url = `${environment.BASE_URL}/tenants/${tenantId}/waiver_mst/${waiverId}`;
    return this.http
      .get(url, this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  markActiveWaiver(waiverId: number, tenantId: number) {
    const url = `${environment.BASE_URL}/tenants/${tenantId}/waiver_mst/${waiverId}/mark_as_active`;
    return this.http
      .post(url, {}, this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  markInActiveWaiver(waiverId: number, tenantId: number) {
    const url = `${environment.BASE_URL}/tenants/${tenantId}/waiver_mst/${waiverId}/mark_as_inactive`;  
    return this.http
      .post(url, {}, this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }
} 